import type { Author, ContributorProfile } from "@app/types/Cue";
import Byline from "@components/Byline/Byline";
import { getAllProfiles } from "@components/Byline/helpers";
import cx from "classnames";

import ArticleTimeStamp from "./ArticleTimeStamp";

type ArticleAuthorsProps = {
  rootClassName?: string;
  authors: Author[];
  contributors: ContributorProfile[];
  publishedDate: string;
  updatedDate: string;
  hasUpdatedTimeDisplayed?: boolean;
};

export default function ArticleAuthorsList({
  rootClassName,
  authors,
  contributors,
  publishedDate,
  updatedDate,
  hasUpdatedTimeDisplayed,
}: ArticleAuthorsProps): React.ReactElement {
  const profiles = getAllProfiles(authors, contributors);

  return (
    <div
      className={cx(
        rootClassName,
        "space-y-4",
        "md:flex md:flex-wrap md:space-y-0"
      )}
      data-testid="article-authors-list-component"
    >
      <Byline
        profiles={profiles}
        imageWidth={65}
        imageHeight={65}
        timeStamp={
          <ArticleTimeStamp
            publishedDate={publishedDate}
            updatedDate={updatedDate}
            hasUpdatedTimeDisplayed={hasUpdatedTimeDisplayed}
          />
        }
      />
    </div>
  );
}
